<script setup lang="ts">
  // ios pwaでキーボードを開いたまま別のアプリにスイッチすると、画面の領域がおかしくなる問題の対応
  // ・BG移行時にtextareaにフォーカスがある場合は要素IDを保持
  // ・FG移行時にはフォーカスしていた要素IDがある場合は、bodyのheightを200svhに変更し、fixed、width:100%、height:100%、z-index:9999の要素を追加
  // (bodyがキーボードエリア分だけ上にずれた状態になるのでbodyのheightを2倍にする)
  // ・被せた要素をクリックでtextareaにfocusさせる。(ios pwaではユーザー操作をトリガーとしないとfocusできないため)

  const showWrapper = ref(false);

  let forcuedElementId: string | null = null;

  const visibilityChange = () => {
    if (document.visibilityState === "visible") {
      // document.activeElementでフォーカスが当たっている要素を取得し、FG移行後にtextareaにフォーカスが当たっていたら何もしないとしたかったが、
      // 内部的にはフォーカスが当たっているが、画面上ではフォーカスが当たってない状況となる。
      // そのため無条件でラッパーを表示することにした
      if (forcuedElementId) {
        // ラッパーを表示
        showWrapper.value = true;
        // bodyのheightを200vhに変更する
        const body = document.getElementsByTagName("body")[0];
        if (!body.classList.contains("input_restore")) {
          body.classList.add("input_restore");
        }
      }
    } else if (document.visibilityState === "hidden") {
      // フォーカスがあたっている要素を取得
      const elem = document.activeElement;
      if (elem && (elem.tagName === "INPUT" || elem.tagName === "TEXTAREA")) {
        // フォーカスがあたっている要素のidを保持
        forcuedElementId = elem.id;
      }
    }
  };

  onMounted(() => {
    if (isIOS() && isPWA()) {
      window.addEventListener("visibilitychange", visibilityChange);
    }
  });

  onUnmounted(() => {
    if (isIOS() && isPWA()) {
      window.removeEventListener("visibilitychange", visibilityChange);
    }
  });

  // ラッパークリックイベント
  const onClick = () => {
    // ラッパーを非表示
    showWrapper.value = false;
    if (forcuedElementId) {
      // bodyのheightを元に戻す
      const body = document.getElementsByTagName("body")[0];
      if (body.classList.contains("input_restore")) {
        body.classList.remove("input_restore");
      }
      // BG移行前にフォーカスが当たっていた要素にフォーカスを当てる
      const elem = document.getElementById(forcuedElementId);
      forcuedElementId = null;
      if (elem && (elem.tagName === "INPUT" || elem.tagName === "TEXTAREA")) {
        elem.focus();
      }
    }
  };
</script>

<template>
  <div v-if="showWrapper" class="restore_wrapper" @click="onClick"></div>
</template>

<style lang="scss">
  .restore_wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 200%;
    z-index: 9999;
    background-color: rgba($color: #000000, $alpha: 0);
  }
  body {
    &.input_restore {
      height: 200svh !important;
    }
  }
</style>
